import { authorizedRequest } from '../index';

import { PaymentOrder } from './paymentOrder.types';

export function getPaymentOrderRequest(mobilPayOrderId: number): Promise<PaymentOrder> {
  return authorizedRequest(true).get(`/payment-order/by/mobilPayOrderId/${mobilPayOrderId}`);
}
